export default __webpack_public_path__ + "static/media/product-07.8b5cfc4c.jpg";